import React from 'react';
import { useTranslation } from 'react-i18next';
import ProductUpdateCard from './ProductUpdateCard';

const ProductUpdateList = ({ updates, onEdit, onDelete }) => {
  const { t } = useTranslation();

  if (updates.length === 0) {
    return (
      <div className="text-center text-gray-500 py-8">
        {t('noUpdates')}
      </div>
    );
  }

  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      {updates.map((update) => (
        <ProductUpdateCard
          key={update.id}
          update={update}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};

export default ProductUpdateList; 